import { useState, useEffect } from "react";
import { apiFetch } from "../../../context/AuthContext";

const useModulePermissions = (BASE_URL) => {
    const [modulePermissions, setModulePermissions] = useState(null);
    const [loadingPermissions, setLoadingPermissions] = useState(true);

    useEffect(() => {
        const fetchModulePermissions = async () => {
            try {
                const clientName = (() => {
                    try {
                        const item = localStorage.getItem("clientName");
                        return item || "";
                    } catch (error) {
                        console.error(`Error accessing localStorage for key: clientName`, error);
                        return "";
                    }
                })();

                if (!clientName) {
                    setLoadingPermissions(false);
                    return;
                }

                const response = await apiFetch(
                    `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
                    { method: 'GET' }
                );

                if (response.ok) {
                    const data = await response.json();
                    setModulePermissions(data?.data);
                } else {
                    setModulePermissions({ privateMessaging: false });
                }
            } catch (error) {
                console.error("Error fetching module permissions:", error);
                setModulePermissions({ privateMessaging: false });
            } finally {
                setLoadingPermissions(false);
            }
        };

        fetchModulePermissions();
    }, [BASE_URL]);

    return { modulePermissions, loadingPermissions };
};

export default useModulePermissions;